// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base container styles */
.parent {
  background: white;
  border-radius: 5px;
  height: 100%;
}

/* Main selectable item styling */
.item-selectable-article {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 2.1px 7.87px 0px rgba(79, 97, 79, 0.1490196078);
  transition: all 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  cursor: pointer;
  /* Reset button styles */
  font-family: inherit;
  font-size: inherit;
  /* Accessibility focus styles */
  /* Keyboard focus only styles */
  /* Hover state */
  /* Selected state - green background */
  /* Selected state - red background (for removal) */
}
.item-selectable-article:focus {
  outline-offset: 2px;
  box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);
}
.item-selectable-article:focus-visible {
  outline-offset: 2px;
  box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);
}
.item-selectable-article:hover {
  background-color: #F6FAF6;
  transform: translateY(-2px);
}
.item-selectable-article.selected {
  border: 2px solid var(--ion-color-primary);
  background: #F6FAF6;
}
.item-selectable-article.selectedRed {
  background: rgba(216, 11, 49, 0.3568627451);
  border: 2px solid #d80b31;
}

/* Item content container */
.item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

/* Selection indicator (checkmark) */
.selection-indicator {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 1;
}
.selection-indicator .selected_item_icon {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.selection-indicator .selected_item_icon.active {
  z-index: 99;
  opacity: 1;
}

/* Item details column */
.item-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* Image container */
.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* Food item image */
.item-selectable-article-image {
  margin: 0 auto;
  height: 90px;
  max-width: 90px;
  object-fit: cover;
}

/* Price tag styling */
.option-price {
  font-size: 12px;
  margin: auto;
  font-weight: bold;
  color: black;
}
.option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}

/* Food item name */
.name {
  margin-top: 12px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: black;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Add button styling */
.wrapp {
  padding: 5px;
  width: 100%;
  margin: 0 auto;
}

.add-button {
  width: 100%;
  margin-top: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
}
.add-button span {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 14px;
}

/* Quantity selector */
.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 20px;
  font-family: AppFontBold;
  margin: 0 8px;
}

/* Quantity buttons */
.quantity-btn {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Focus-visible styles */
  /* Hover styles */
  /* Visually indicate pressed state */
  /* Icon sizing */
}
.quantity-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-btn:active {
  transform: scale(0.95);
}
.quantity-btn.add-opacity {
  opacity: 0.5;
}
.quantity-btn ion-icon {
  width: 20px;
  height: 20px;
}

/* VAT information */
.vat {
  color: black;
  font-size: 10px;
}

/* High contrast mode enhancements */
.bsg-high-contrast {
  /* Selection icon in high contrast */
  /* Item text in high contrast */
  /* Add button in high contrast */
  /* Quantity buttons in high contrast */
}
.bsg-high-contrast .item-selectable-article {
  border: 2px solid black;
  /* Selected states in high contrast */
}
.bsg-high-contrast .item-selectable-article:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .item-selectable-article.selected {
  border: 3px solid black;
  background: white;
}
.bsg-high-contrast .item-selectable-article.selectedRed {
  border: 3px dashed black;
  background: white;
}
.bsg-high-contrast .selected_item_icon.active {
  border: 1px solid black;
}
.bsg-high-contrast .name, .bsg-high-contrast .option-price, .bsg-high-contrast .quantity {
  color: black;
}
.bsg-high-contrast .add-button {
  border: 2px solid black;
}
.bsg-high-contrast .add-button span {
  color: black;
  font-weight: bold;
}
.bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .name {
    font-size: 12px;
  }
  .item-selectable-article-image {
    height: 70px;
    max-width: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,0BAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAKA,iCAAA;AACA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0CAAA;EACA,+DAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EAEA,wBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,+BAAA;EAOA,+BAAA;EAOA,gBAAA;EAMA,sCAAA;EAMA,kDAAA;AA1BF;AACE;EAEE,mBAAA;EACA,oDAAA;AAAJ;AAIE;EAEE,mBAAA;EACA,oDAAA;AAHJ;AAOE;EACE,yBAAA;EACA,2BAAA;AALJ;AASE;EACE,0CAAA;EACA,mBAAA;AAPJ;AAWE;EACE,2CAAA;EACA,yBAAA;AATJ;;AAaA,2BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAVF;;AAaA,oCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAVF;AAYE;EACE,UAAA;EACA,oCAAA;AAVJ;AAYI;EACE,WAAA;EACA,UAAA;AAVN;;AAeA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAZF;;AAeA,oBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAZF;;AAeA,oBAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAZF;;AAeA,sBAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAZF;AAcE;EACE,gBAAA;EACA,gBAAA;AAZJ;;AAgBA,mBAAA;AACA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EAEA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAdF;;AAiBA,uBAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,cAAA;AAdF;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;AAdF;AAgBE;EACE,wBAAA;EACA,iCAAA;EACA,eAAA;AAdJ;;AAkBA,sBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAfF;AAiBE;EACE,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;AAfJ;;AAmBA,qBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,yBAAA;EAMA,iBAAA;EAKA,oCAAA;EASA,gBAAA;AAvCF;AAcE;EACE,2CAAA;EACA,mBAAA;AAZJ;AAgBE;EACE,2CAAA;EACA,mBAAA;AAdJ;AAkBE;EACE,qCAAA;AAhBJ;AAoBE;EACE,sBAAA;AAlBJ;AAqBE;EACE,YAAA;AAnBJ;AAuBE;EACE,WAAA;EACA,YAAA;AArBJ;;AAyBA,oBAAA;AACA;EACE,YAAA;EACA,eAAA;AAtBF;;AAyBA,oCAAA;AACA;EAqBE,oCAAA;EAKA,+BAAA;EAKA,gCAAA;EAUA,sCAAA;AA3DF;AAmBE;EACE,uBAAA;EAOA,qCAAA;AAvBJ;AAkBI;EACE,0BAAA;EACA,gBAAA;AAhBN;AAoBI;EACE,uBAAA;EACA,iBAAA;AAlBN;AAqBI;EACE,wBAAA;EACA,iBAAA;AAnBN;AAwBE;EACE,uBAAA;AAtBJ;AA0BE;EACE,YAAA;AAxBJ;AA4BE;EACE,uBAAA;AA1BJ;AA4BI;EACE,YAAA;EACA,iBAAA;AA1BN;AAgCI;EACE,0BAAA;AA9BN;AAiCI;EACE,YAAA;AA/BN;;AAoCA,2BAAA;AC9RE;EDgSA;IACE,eAAA;EAjCF;EAoCA;IACE,YAAA;IACA,eAAA;EAlCF;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n/* Base container styles */\n.parent {\n  background: white;\n  border-radius: 5px;\n  height: 100%;\n\n}\n\n/* Main selectable item styling */\n.item-selectable-article {\n  position: relative;\n  margin: 0 auto;\n  flex-grow: 1;\n  min-height: 100%;\n  word-break: break-word;\n  background: white;\n  border: 2px solid white;\n  border-radius: var(--custom-border-radius);\n  box-shadow: 0px 2.1px 7.87px 0px #4F614F26;\n  transition: all 200ms linear;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n  cursor: pointer;\n  \n  /* Reset button styles */\n  font-family: inherit;\n  font-size: inherit;\n  \n  /* Accessibility focus styles */\n  &:focus {\n\n    outline-offset: 2px;\n    box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Keyboard focus only styles */\n  &:focus-visible {\n\n    outline-offset: 2px;\n    box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: #F6FAF6;\n    transform: translateY(-2px);\n  }\n  \n  /* Selected state - green background */\n  &.selected {\n    border: 2px solid var(--ion-color-primary);\n    background: #F6FAF6;\n  }\n  \n  /* Selected state - red background (for removal) */\n  &.selectedRed {\n    background: #d80b315b;\n    border: 2px solid #d80b31;\n  }\n}\n\n/* Item content container */\n.item-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n\n/* Selection indicator (checkmark) */\n.selection-indicator {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  z-index: 1;\n  \n  .selected_item_icon {\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    \n    &.active {\n      z-index: 99;\n      opacity: 1;\n    }\n  }\n}\n\n/* Item details column */\n.item-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n/* Image container */\n.image-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n/* Food item image */\n.item-selectable-article-image {\n  margin: 0 auto;\n  height: 90px;\n  max-width: 90px;\n  object-fit: cover;\n}\n\n/* Price tag styling */\n.option-price {\n  font-size: 12px;\n  margin: auto;\n  font-weight: bold;\n  color: black;\n  \n  &.no-price {\n    min-height: 12px;\n    max-height: 12px;\n  }\n}\n\n/* Food item name */\n.name {\n  margin-top: 12px;\n  font-size: 14px;\n  width: 100%;\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n\n  color: black;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical ;\n  overflow: hidden ;\n  text-overflow: ellipsis;\n}\n\n/* Add button styling */\n.wrapp {\n  padding: 5px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.add-button {\n  width: 100%;\n  margin-top: 10px;\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--ion-color-secondary);\n  border-radius: 8px;\n  \n  span {\n    font-family: AppFontBold;\n    color: var(--ion-color-secondary);\n    font-size: 14px;\n  }\n}\n\n/* Quantity selector */\n.quantity-selector {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n  \n  .quantity {\n    color: var(--ion-color-secondary);\n    font-size: 20px;\n    font-family: AppFontBold;\n    margin: 0 8px;\n  }\n}\n\n/* Quantity buttons */\n.quantity-btn {\n  width: 30px;\n  height: 30px;\n  background: transparent;\n  border: none;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 50%;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Focus-visible styles */\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Hover styles */\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n  \n  /* Visually indicate pressed state */\n  &:active {\n    transform: scale(0.95);\n  }\n  \n  &.add-opacity {\n    opacity: 0.5;\n  }\n  \n  /* Icon sizing */\n  ion-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* VAT information */\n.vat {\n  color: black;\n  font-size: 10px;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .item-selectable-article {\n    border: 2px solid black;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n      box-shadow: none;\n    }\n    \n    /* Selected states in high contrast */\n    &.selected {\n      border: 3px solid black;\n      background: white;\n    }\n    \n    &.selectedRed {\n      border: 3px dashed black;\n      background: white;\n    }\n  }\n  \n  /* Selection icon in high contrast */\n  .selected_item_icon.active {\n    border: 1px solid black;\n  }\n  \n  /* Item text in high contrast */\n  .name, .option-price, .quantity {\n    color: black;\n  }\n  \n  /* Add button in high contrast */\n  .add-button {\n    border: 2px solid black;\n    \n    span {\n      color: black;\n      font-weight: bold;\n    }\n  }\n  \n  /* Quantity buttons in high contrast */\n  .quantity-btn {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n  }\n}\n\n/* Responsive adjustments */\n@include mobile {\n  .name {\n    font-size: 12px;\n  }\n  \n  .item-selectable-article-image {\n    height: 70px;\n    max-width: 70px;\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
